import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Auth.css';

function CheckEmail() {
  const location = useLocation();
  const { resendVerification } = useAuth();
  const initialEmail = location.state?.email || '';
  const [email, setEmail] = useState(initialEmail);
  const [status, setStatus] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleResend = async () => {
    const addr = email.trim();
    if (!addr) {
      setError('Enter your email address.');
      return;
    }
    setError('');
    setStatus('');
    setLoading(true);
    const r = await resendVerification(addr);
    setLoading(false);
    if (r.success) {
      setStatus('If an account exists for that email and it is not verified, we sent a new link.');
    } else {
      setError(r.error);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-brand">
          <img src="/tradelensy-logo.png" alt="Tradelensy logo" className="auth-logo" />
          <h1>Tradelensy</h1>
        </div>
        <h2>Verify your email</h2>
        <p style={{ color: '#666', lineHeight: 1.5 }}>
          {initialEmail
            ? (
              <>
                We sent a verification link to <strong>{initialEmail}</strong>. Open it within 48 hours, then log in.
              </>
            )
            : (
              'Enter the email you used to register. We will send a new verification link if the account is still unverified.'
            )}
        </p>
        <div className="form-group" style={{ marginTop: '20px' }}>
          <label>Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={loading}
          />
        </div>
        {error && <div className="error-message">{error}</div>}
        {status && (
          <div
            style={{
              marginTop: '12px',
              padding: '12px',
              borderRadius: '4px',
              background: '#d4edda',
              color: '#155724',
              fontSize: '14px',
            }}
          >
            {status}
          </div>
        )}
        <button
          type="button"
          className="btn btn-primary"
          style={{ marginTop: '12px', width: '100%' }}
          disabled={loading}
          onClick={handleResend}
        >
          {loading ? 'Sending…' : 'Resend verification email'}
        </button>
        <p className="auth-link">
          <Link to="/login">Back to login</Link>
        </p>
      </div>
    </div>
  );
}

export default CheckEmail;
